import { Center, Text, VStack } from '@chakra-ui/react';
import { LoadingIndicator } from '@/components/shared/LoadingIndicator';

export function LoadingState({
  message = 'Loading…',
  minH = '240px',
}: {
  message?: string;
  minH?: string;
}) {
  return (
    <Center minH={minH} w="full" role="status" aria-live="polite" aria-busy="true">
      <VStack gap="3">
        <LoadingIndicator size="md" decorative />
        <Text fontSize="sm" color="ui.text.secondary">
          {message}
        </Text>
      </VStack>
    </Center>
  );
}
